import { Stepper, type StepperStep } from '@/components/ui/stepper';
import { ALL_STEPS, STEP_LABELS } from './stepRouting';

/** The publish flow's steps as a Stepper: steps its path skips stay in place, dimmed, and a gated step says why. */
export function StepIndicator<TStep extends string>({
  current,
  visibleSteps,
  onStepClick,
  disabled,
  submitted,
  getStepDisableReason,
  getStepSatisfied,
  allSteps = ALL_STEPS as readonly TStep[],
  labels = STEP_LABELS as Record<TStep, string>,
}: {
  current: TStep;
  visibleSteps: TStep[];
  onStepClick: (id: TStep) => void;
  disabled: boolean;
  submitted: boolean;
  getStepDisableReason?: (id: TStep) => string | undefined;
  getStepSatisfied?: (id: TStep) => boolean;
  allSteps?: readonly TStep[];
  labels?: Record<TStep, string>;
}) {
  const steps = allSteps.map((id): StepperStep => {
    const visible = visibleSteps.includes(id);
    const isCurrent = id === current && !submitted;
    const blockReason = !isCurrent && visible ? getStepDisableReason?.(id) : undefined;
    return {
      id,
      label: labels[id],
      state: isCurrent ? (getStepSatisfied?.(id) ? 'current-done' : 'current') : visible && getStepSatisfied?.(id) ? 'done' : 'todo',
      disabled: !visible || blockReason != null,
      tooltip: blockReason,
    };
  });

  return (
    <div className="px-6 py-4 border-b-lureo-border-width border-lureo-line bg-lureo-neutral-subtle">
      <Stepper
        steps={steps}
        onSelect={disabled ? undefined : (id) => {
          if (id !== current) onStepClick(id as TStep);
        }}
      />
    </div>
  );
}
